export const metadataQuery = (market: string) => ({
  reason_code: {
    format: 'supply_outages',
    source: 'reason_codes',
  },
  terminal: {
    source: 'locations',
    type: 'Terminal',
    market: market?.length > 0 ? market : 'None',
    format: 'id_name',
  },
  product: {
    format: 'id_name',
    source: 'products',
  },
  product_group: {
    format: 'product_groups',
    source: 'products',
  },
  supplier: {
    format: 'id_name',
    source: 'counterparties',
    type: 'Supplier',
  },
  price_type: {
    format: 'price_types',
    source: 'prices',
  },
  contract: {
    format: 'contracts',
    source: 'prices',
  },
  supply_owner: {
    format: 'supply_owners',
    source: 'prices',
  },
})
